import { TemplateConfig } from '../../core/config.scorecard.model';
import { Message } from '../../core/definition.scorecard.model';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ScorecardGridDirectType,
    TemplateMode,
} from '../../core/template-definition.model';
import { Column, Row, Sort } from '../../experimental.grid';
import { ScorecardAttributes } from '../../scorecard.model';

import { ColumnContext, RowContext } from './grid.model';

// this might move
export interface PerformanceGrid {
    superGroupName?: string;
    periodStartDate?: Date;
    periodEndDate?: Date;
    scorecardId?: number;
    published?: boolean;
    generatedOn?: Date;
    canExpandMetrics?: boolean;
    columns?: Array<Column<ColumnContext>>;
    rows?: Array<Row<RowContext>>;
    sortDefs: Sort[];
}

export interface GridState {
    mode: TemplateMode;
    performanceGrid: PerformanceGrid;
    prevPerformanceGrid: PerformanceGrid;
    attributes: ScorecardAttributes[];
    messages: Message[];
    teamGrid: {};
    headerList: number[];
    tplConfig: TemplateConfig;
}

export const defaultGridState = (): GridState => ({
    mode: TemplateMode.PERFORMER,
    performanceGrid: {
        sortDefs: [],
    },
    prevPerformanceGrid: {
        sortDefs: [],
    },
    teamGrid: {},
    attributes: [],
    messages: [],
    headerList: [],
    tplConfig: {
        identifier: '',
        mode: TemplateMode.PERFORMER,
        containerColour: '',
        widgets: [],
        layouts: [],
        pillars: [
            {
                identifier: '',
                name: '',
                displayOrder: 0,
            },
        ],
        messages: [],
    },
});
